module.exports = __webpack_public_path__ + "img/logo_sspp_white.0d7efcf7.png";